import { css } from '@emotion/react';
import styled from '@emotion/styled';

import type { StyledTabItemProps } from './types';

export const StyledTabItem = styled.div<StyledTabItemProps>`
  position: relative;

  /* Disabled state */
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.6;
      background: #f9f9f9;
      border-color: #e1e1e1;
    `}

  /* Dragging state */
  ${({ $isDragging }) =>
    $isDragging &&
    css`
      opacity: 0.8;
      transform: rotate(2deg);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border-color: #007cba;
      z-index: 1000;
    `}
`;

export const StyledTabHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  min-height: 60px;
`;

export const StyledTabTitle = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #1e1e1e;
  margin-bottom: 4px;
  line-height: 1.4;
`;

export const StyledTabActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledToggleWrapper = styled.div`
  display: flex;
  align-items: center;

  /* Reset any default margins for toggle components */
  > * {
    margin: 0;
  }
`;

export const StyledActionButton = styled.div`
  .components-button {
    width: 36px;
    height: 36px;
    min-width: 36px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;

    &.redfox-global-tab-item__edit-btn {
      border-color: #007cba;
      color: #007cba;

      &:hover {
        background: #007cba;
        color: #fff;
      }
    }

    &.redfox-global-tab-item__delete-btn {
      border-color: #d63638;
      color: #d63638;

      &:hover {
        background: #d63638;
        color: #fff;
      }
    }
  }
`;
